// Shared generic-envelope phone validator (rule 4).
//
// TWIN FILE: supabase/functions/_shared/phoneValidation.ts holds the same
// logic and the same PHONE_ERROR_MESSAGE for edge functions (CRA cannot
// import from supabase/, Deno cannot import from src/). Keep them in sync;
// phoneValidation.test.js runs one fixtures file against both.
//
// This is a generic envelope check only — optional leading "+", 4-15
// digits total — with no per-country awareness (see phoneCountries.js for
// the frontend's per-country digit-length rules, D7 of ticket 009's plan).
// It exists so the edge function has a minimal, country-agnostic safety
// net; it is NOT the primary UX validator (that's
// phoneCountries.js's validatePhoneForCountry, used by AdvisorConnectForm).

export const PHONE_ERROR_MESSAGE = 'Please enter a valid phone number.'

export function normalizePhone(raw) {
  return typeof raw === 'string' ? raw.trim() : ''
}

function isValidFormat(phone) {
  return /^\+?[0-9]{4,15}$/.test(phone)
}

export function validatePhone(raw) {
  const phone = normalizePhone(raw)
  if (!isValidFormat(phone)) return { ok: false, phone, error: PHONE_ERROR_MESSAGE }
  return { ok: true, phone, error: null }
}
